<template>
  <section class="bg-top">
    <div class="container">
      <h1 class="tit">
        <strong>Lifening</strong>
        PRODUCTS
      </h1>
      <p class="desc mt-2">현재를 가꾸는 당신에게, <span class="mbr"></span>라이프닝<span class="brs"></span>Lifening, to you</p>
    </div>
  </section>
</template>

<script>

export default {
  name: 'TopArea',
};
</script>

<style lang='scss' scoped>
.bg-top{
  background: #f9e3d5 url(~@/assets/images/product/visual.png) no-repeat top;
  padding: 3.5rem 0;
  margin-top: -3.5rem;
  height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: $mobile-size) {
    background-image: url(~@/assets/images/product/visual_mo.png?220628);
    margin-top: 0;
    background-position-x: 50%;
    align-items: flex-start;
  }
  .tit{
    font-size: 4.2rem;
    font-weight: 300;
    color: #F2675D;
    line-height: 1.2;
    strong{
      font-weight: 500;
      @media (max-width: $mobile-size) {
        display: block;
      }
    }
  }
  .desc{
    font-size: 1.6rem;
    font-weight: 300;
    color: #282828;
    line-height: 1.5;
    // span{
    //   display: block;
    // }
  }
}
@media (max-width: $mobile-size) {
  .bg-top{
    padding: 4rem 0;
    background-size: cover;
    .tit{
      font-size: 3.2rem;
      // line-height: 4.2rem;
    }
    .desc{
      font-size: inherit;
      // line-height: 1.8;
    }
  }
}
</style>
